var start = function () {
  $('#viewer .fbg').click(function(){
    $(this).closest('.senv').find('.img').click();
  });
}
export default {
  start,
}



//////////////////
// WEBPACK FOOTER
// ./static/viewer/start.js
// module id = elrP
// module chunks = 1